
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Message 全局提示</h1>
<p>信息反馈。在顶部居中显示并自动消失。有多种提示状态可选择。</p>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCYF">
                <template slot="description"><p>普通提示，默认3秒后消失。显示位置距离视口顶部20px。可选类型提示 <code>info</code> <code>success</code> <code>warning</code> <code>error</code> 。</p>
</template>
                <template slot="title">基础用法 <a href="#JCYF" data-title="基础用法">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Button type=&quot;info&quot; @click=&quot;openMessage('info')&quot;&gt;info&lt;/Button&gt;
    &lt;Button type=&quot;success&quot; @click=&quot;openMessage('success')&quot;&gt;success&lt;/Button&gt;
    &lt;Button type=&quot;warning&quot; @click=&quot;openMessage('warning')&quot;&gt;warning&lt;/Button&gt;
    &lt;Button type=&quot;danger&quot; @click=&quot;openMessage('error')&quot;&gt;error&lt;/Button&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          
        }
      },
      methods: {
        openMessage(type){
          this.$Message[type](`this is a ${type} message`);
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="JZZ">
                <template slot="description"><p>loading状态。异步在某个合适的时机移除。</p>
</template>
                <template slot="title">加载中 <a href="#JZZ" data-title="加载中">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Button @click=&quot;loading&quot;&gt;loading&lt;/Button&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          
        }
      },
      methods: {
        loading(){
            let msg = this.$Message.loading({
              duration: 0,
              content: 'this is a loading message',
            });
            setTimeout(()=&gt;{
              msg.close();
            },3000)
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="DBJSDTS">
                <template slot="description"><p>设置<code>background</code>属性可以实现带有背景色的提示。</p>
</template>
                <template slot="title">带背景色的提示 <a href="#DBJSDTS" data-title="带背景色的提示">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Button type=&quot;info&quot; @click=&quot;openMessage('info')&quot;&gt;info&lt;/Button&gt;
    &lt;Button type=&quot;success&quot; @click=&quot;openMessage('success')&quot;&gt;success&lt;/Button&gt;
    &lt;Button type=&quot;warning&quot; @click=&quot;openMessage('warning')&quot;&gt;warning&lt;/Button&gt;
    &lt;Button type=&quot;danger&quot; @click=&quot;openMessage('error')&quot;&gt;error&lt;/Button&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          
        }
      },
      methods: {
        openMessage(type){
            this.$Message[type]({
                content: `this is a ${type} backgroundColor`,
                background: true,
            })
        }
      }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="PD">
                <template slot="description"><p><code>content</code>属性支持配置HTML片段。</p>
</template>
                <template slot="title">HTML片段 <a href="#PD" data-title="HTML片段">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Button @click=&quot;configMessage&quot;&gt;自定义配置&lt;/Button&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
        methods: {
            configMessage(){
                this.$Message.info({
                    duration: 3000,
                    content: '&lt;b&gt;this is a config message&lt;/b&gt;',
                    // 触发关闭时的回调
                    onClose(){
                        console.log('message close');
                    }
                });
            }
        }
    }
&lt;/script&gt;

</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="message-instance" class="anchor-title">Message instance <a class="header-anchor" href="#message-instance">#</a></h3>
<p>直接通过一下方法来使用组件：</p>
<ul>
<li>
<p><code>this.$Message.info(config)</code></p>
</li>
<li>
<p><code>this.$Message.success(config)</code></p>
</li>
<li>
<p><code>this.$Message.warning(config)</code></p>
</li>
<li>
<p><code>this.$Message.error(config)</code></p>
</li>
<li>
<p><code>this.$Message.loading(config)</code></p>
</li>
</ul>
<p>参数<code>config</code>可以是字符串或对象。当为字符串时为提示内容，可以配置第二个参数，此参数为时间，如：<code>this.$Message.info('this a message', 3000)</code>。当为对象时具体配置如下：</p>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>content</td>
<td>String</td>
<td>提示内容，支持html字符串</td>
<td>-</td>
</tr>
<tr>
<td>duration</td>
<td>Number</td>
<td>自动关闭的延时，单位秒，值为0时不关闭</td>
<td>3000</td>
</tr>
<tr>
<td>background</td>
<td>Boolean</td>
<td>是否显示背景色</td>
<td>false</td>
</tr>
<tr>
<td>closable</td>
<td>Boolean</td>
<td>是否显示关闭按钮</td>
<td>false</td>
</tr>
<tr>
<td>onClose</td>
<td>Function</td>
<td>关闭时的回调</td>
<td>-</td>
</tr>
</tbody>
</table>
<p>另外提供全局配置的方法：</p>
<ul>
<li><code>this.$Message.config(config)</code></li>
</ul>
<p>参数<code>config</code>为对象。具体配置如下：</p>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>top</td>
<td>Number</td>
<td>提示组件距离顶部的距离，单位px</td>
<td>20</td>
</tr>
<tr>
<td>duration</td>
<td>Number</td>
<td>自动关闭的延时，单位毫秒，值为0时不关闭</td>
<td>3000</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Button',{attrs:{"type":"info"},on:{"click":function($event){return _vm.openMessage('info')}}},[_vm._v("info")]),_vm._v(" "),_c('Button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.openMessage('success')}}},[_vm._v("success")]),_vm._v(" "),_c('Button',{attrs:{"type":"warning"},on:{"click":function($event){return _vm.openMessage('warning')}}},[_vm._v("warning")]),_vm._v(" "),_c('Button',{attrs:{"type":"danger"},on:{"click":function($event){return _vm.openMessage('error')}}},[_vm._v("error")])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          
        }
      },
      methods: {
        openMessage(type){
          this.$Message[type](`this is a ${type} message`);
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Button',{on:{"click":_vm.loading}},[_vm._v("loading")])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          
        }
      },
      methods: {
        loading(){
            let msg = this.$Message.loading({
              duration: 0,
              content: 'this is a loading message',
            });
            setTimeout(()=>{
              msg.close();
            },3000)
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Button',{attrs:{"type":"info"},on:{"click":function($event){return _vm.openMessage('info')}}},[_vm._v("info")]),_vm._v(" "),_c('Button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.openMessage('success')}}},[_vm._v("success")]),_vm._v(" "),_c('Button',{attrs:{"type":"warning"},on:{"click":function($event){return _vm.openMessage('warning')}}},[_vm._v("warning")]),_vm._v(" "),_c('Button',{attrs:{"type":"danger"},on:{"click":function($event){return _vm.openMessage('error')}}},[_vm._v("error")])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          
        }
      },
      methods: {
        openMessage(type){
            this.$Message[type]({
                content: `this is a ${type} backgroundColor`,
                background: true,
            })
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Button',{on:{"click":_vm.configMessage}},[_vm._v("自定义配置")])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        methods: {
            configMessage(){
                this.$Message.info({
                    duration: 3000,
                    content: '<b>this is a config message</b>',
                    // 触发关闭时的回调
                    onClose(){
                        console.log('message close');
                    }
                });
            }
        }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  